/** Delay before refining the pan to avoid card after initial pan. */
export const REFINEMENT_DELAY_MS = 100;

export const MIN_HEIGHT_DIFFERENCE_FOR_REFINEMENT_PX = 20;

/** Buffer added to the top of the card, so items cannot be flush against the top edge of the card */
export const MOBILE_PAN_OFFSET = 20;

/**
 * Default fraction to pad bounds before computing visibility and zoom.
 * Provides breathing room so entities aren't flush against the viewable area edge.
 */
export const DEFAULT_BOUNDS_PAD_RATIO = 0.2;

/**
 * Default zoom in difference threshold
 * The map only zooms when the required zoom differs from current by at least this much.
 */
export const DEFAULT_BOUNDS_ZOOM_DIFF_THRESHOLD = 4;

/**
 * Zoom level when focusing marker-like entities (no bounds).
 */
export const DEFAULT_POINT_FOCUS_ZOOM = 18;

/**
 * Minimum available viewport dimension (px, per axis) required to attempt fitting bounds to zoom.
 * When either axis falls below this threshold, the map keeps its current zoom and only pans.
 */
export const MIN_FITTING_DIMENSION_PX = 200;
